import { createSlice } from '@reduxjs/toolkit'
import { actions as clientActions } from '@gocanvas/client'
const { loadFormData } = clientActions

export const accountLiveDataSourcesSlice = createSlice({
  name: 'liveDataSources',
  initialState: [],
  reducers: {
    addLiveData(state, action) {
      state.push(action.payload)
      return state
    }
  },
  extraReducers: builder => {
    builder.addCase(loadFormData, (state, action) => {
      const { liveDataSources = [] } = action.payload
      return liveDataSources
    })
  },
})

export const { actions, reducer } = accountLiveDataSourcesSlice
export default reducer
